import * as React from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  background?: string;
  onClose: () => void;
}

export const CustomDialogTitle = (props: DialogTitleProps) => {
  const { children, background, onClose, ...other } = props;

  return (
    <DialogTitle
      style={{ background: `${background}` }}
      sx={{
        display: "flex",
        justifyContent: "space-between",
        padding: 0,
        alignItems: "center",
        fontSize: "16px",
        fontWeight:'400',
        color: "#000000",
        borderBottom: "1px solid #cccccc",
        paddingBottom: "3px",
        marginBottom: "10px",
      }}
      {...other}
    >
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 12,
            top: 12,
            color: "#acacac",
            "&:hover": {
              color: "#000000",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};
